<template>
	<div>
		<v-tabs v-model="tab_select"
			fixed-tabs
			:color="media_color"
			height="60" 
			background-color="rgba(250, 250, 250, 1)"
			active-class="active"
			hide-slider
		>
			<v-tab v-for="tab in tab_items" :key="tab.value" :disabled="!tab.disabled">
				<span class="text-capitalize tab-text">{{ tab.text }}</span>
			</v-tab>
		</v-tabs>
		<template v-if="tab_select === 0">
			<MediaHoldingFileUpload
				:color="media_color"
				@file="file_id = $event; tab_select = 1;"
			/>
		</template>
		<template v-if="tab_select === 1">
			<MediaHoldingMatchCode
				:color="media_color"
				:fileId="file_id"
				@tab-able="onTabAble($event)"
			/>
		</template>
		<template v-if="tab_select === 2">
			<MediaHoldingExceptions
				:color="media_color"
				:fileId="file_id"
			/>
		</template>
		<template v-if="tab_select === 3">
			<MediaHoldingNoHoldings
				:color="media_color"
				:fileId="file_id"
			/>
		</template>
		<template v-if="tab_select === 4">
			<MediaHoldingInvoice
				:color="media_color"
				:fileId="file_id"
			/>
		</template>
		<template v-if="tab_select === 5">
			<MediaHoldingMatches
				:color="media_color"
				:fileId="file_id"
			/>
		</template>
	</div>
</template>

<script>
import MediaHoldingFileUpload from "@/views/desktop/media/radio_holdings/media_holding_file_upload.vue";
import MediaHoldingMatchCode from "@/views/desktop/media/radio_holdings/media_holding_match_code.vue";
import MediaHoldingExceptions from "@/views/desktop/media/radio_holdings/media_holding_exceptions.vue";
import MediaHoldingNoHoldings from "@/views/desktop/media/radio_holdings/media_holding_no_holdings.vue";
import MediaHoldingInvoice from "@/views/desktop/media/radio_holdings/media_holding_invoice.vue";
import MediaHoldingMatches from "@/views/desktop/media/radio_holdings/media_holding_matches.vue";


const Tab_Items = [
	{
		text: 'File upload',
		value: 'upload',
		disabled: true
	},
	{
		text: 'Match codes',
		value: 'matchcodes',
		disabled: false
	},
	{
		text: 'Exceptions',
		value: 'exceptions',
		disabled: false
	},
	{
		text: 'No Holdings',
		value: 'noholdings',
		disabled: false
	},
	{
		text: 'Invoice Queries',
		value: 'invoice',
		disabled: false
	},
	{
		text: 'Matches',
		value: 'matches',
		disabled: false
	},
];

export default {
	name: 'MediaHolding',
	data() {
		this.media_color = '#605AF6';
		
		return {
			tab_items: Tab_Items,
			tab_select: 0,
			file_id: 0,
		}
	},
	components: {
		MediaHoldingFileUpload,
		MediaHoldingMatchCode,
		MediaHoldingExceptions,
		MediaHoldingNoHoldings,
		MediaHoldingInvoice,
		MediaHoldingMatches
	},
	created() {
	},
	computed: {
	},
	watch: {
	},
	methods: {	
		onTabAble(is_able) {
			this.tab_items.forEach(tab => {
				tab.disabled = is_able;
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.active {
  background-color: rgba(96, 90, 246, 0.1) !important;
}
.tab-text {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
}
</style>